import useNavigateWithSearch from '../../../../../../hooks/useNavigateWithSearch';
import { Button, BUTTON_TYPE, BUTTON_SIZE } from '../../../../global/Button';
import Radio from '../../../../global/Mui/Radio';
import FormControlLabel from '../../../../global/Mui/FormControlLabel';
import { ROUTE_MEMBERSHIP } from '../../../../config/routes';

import useScrollToTop from '../../../../utils/hooks/useScrollToTop';

import './CommentsStep.scss';

const COMMENTS = [
  {
    id: '1',
    description: 'Not saving enough',
  },
  {
    id: '2',
    description: 'Fees are too high',
  },
  {
    id: '3',
    description: 'Want to take a break',
  },
  {
    id: '4',
    description: 'Not satisfied with the perks',
  },
  {
    id: '5',
    description: 'Something else',
  },
];

const CommentsStep = ({ onHandleNext, setComments, comments, setReason, reason }) => {
  useScrollToTop();
  const navigateWithSearch = useNavigateWithSearch();

  return (
    <div className="CommentsStep">
      <div className="CommentsStep__container">
        <div className="CommentsStep__container--content">
          <div className="CommentsStep__container--header">
            <div className="CommentsStep__container--header-title">
              Why do you want to cancel?
            </div>
            <div className="CommentsStep__container--header-description">
              We’ll use this to improve our Trashie Unlimited membership.
            </div>
          </div>
          <div className="CommentsStep__container--content-comments">
            <div className="CommentsStep__container--content-comments-list">
              {COMMENTS.map((comment) => (
                <div className="CommentsStep__container--content-comments-list-comment" key={comment.id}>
                  <FormControlLabel
                    key={comment.id}
                    label={comment.description}
                    labelPlacement="start"
                    control={(
                      <Radio
                        id={comment.id}
                        key={comment.id}
                        name="comments"
                        value={comment.id}
                        checked={comments?.id === comment.id}
                        onChange={() => setComments(comment)}
                      />
                  )}
                  />
                </div>
              ))}
            </div>
            <textarea className="CommentsStep__container--content-textarea" placeholder="Tell us more (optional)" value={reason} onChange={(e) => setReason(e.target.value)} />
          </div>
        </div>

        <div className="CommentsStep__container--footer">
          <Button
            type={BUTTON_TYPE.LINK_SEPTENARY}
            size={BUTTON_SIZE.LARGE}
            onClick={onHandleNext}
            disabled={!comments?.id}
          >
            Continue to cancel
          </Button>
          <Button
            type={BUTTON_TYPE.QUATERNARY}
            size={BUTTON_SIZE.LARGE}
            onClick={() => navigateWithSearch(ROUTE_MEMBERSHIP)}
          >
            Keep Trashie Unlimited
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CommentsStep;
